// extracted by mini-css-extract-plugin
module.exports = {"productImg":"PartsComponent_productImg__NubU1"};